export default "/_next/static/chunks/fonts/Montserrat-LightItalic-latin-0fc67534b1c87ac67f2bd1501898889c.woff2";